/**
 * Tabitto 通知フック
 * 共通フックを使用し、全通知タイプを表示
 */
import {
  useNotifications as useNotificationsCore,
  useMarkNotificationRead as useMarkNotificationReadCore,
  useMarkAllNotificationsRead as useMarkAllNotificationsReadCore,
  useDeleteNotification as useDeleteNotificationCore,
  notificationKeys,
} from "@tabipla/hooks/notifications";
import { apiClient } from "../../infrastructure/api/client";

// Re-export query keys for direct access if needed
export { notificationKeys };

// Tabitto shows all notification types (no filter)
export function useNotifications() {
  return useNotificationsCore({ apiClient });
}

export function useMarkNotificationRead() {
  return useMarkNotificationReadCore({ apiClient });
}

export function useMarkAllNotificationsRead() {
  return useMarkAllNotificationsReadCore({ apiClient });
}

export function useDeleteNotification() {
  return useDeleteNotificationCore({ apiClient });
}
